{
  "components": {
    "columns": {
      "composition": "Composition",
      "reference": "Référence",
      "supplier": "Fournisseur"
    },
    "search": "Rechercher des composants par référence, composition ou fournisseur."
  },
  "menus": {
    "businessPartners": "Partenaires commerciaux",
    "components": "Composants",
    "products": "Produits"
  },
  "products": {
    "columns": {
      "collection": "Collection",
      "color": "Couleur",
      "dyeingCountry": "Pays de teinture",
      "mainFabric": "Tissu Principal",
      "manufacturer": "Fournisseur direct",
      "manufacturingCountry": "Pays de confection",
      "name": "Nom",
      "qrCode": "Infos AGEC",
      "recycledMaterialPercentage": "Pourcentage de matière recyclée",
      "reference": "Référence",
      "releaseMicroplastics": "Relâche des microplastiques",
      "weavingCountry": "Pays de tissage"
    },
    "search": "Rechercher des produits par mot-clé, nom, collection, couleur, opération, etc.",
    "toggleAgecView": "Vue AGEC"
  },
  "title": "Bibliothèque"
}
